/* eslint-disable react/prop-types */
/* eslint-disable */
import { useState, useMemo, useEffect } from 'react';
import PropTypes, { number } from 'prop-types';
import { Row, Col, Form, Select } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import InfoModal from 'components/InfoModal/InfoModal';
import { ALERT_ERROR_TYPE } from 'constants/alertTypes';
import { selectCatalogByName, selectCatalogs } from 'selectors/catalogos.selectors';
import { selectCatalogoBeneficiados } from 'selectors/catalogoBeneficiados.selector';
import { upsertMonitoreosEventos } from 'actions/monitoreos.actions';
import { showAlert } from 'actions/alert.actions';
import { PROCESOS_ELECTORALES } from 'constants/nombresCatalogos';
import {
  formatoEdicionMonitoreoEventos,
  formatFromBackToForm
} from 'adapters/formatoMonitoreoEventos';
import { Modal, Accordion, LoadingCard, EstatusFormulario } from 'components';
import {
  newScrollToErrorField,
  encontrarActiveKeyPorValor
} from 'utils/form/newScrollToErrorField';
import { useSetSignerFieldsVisits } from 'hooks/useSetSignerFieldsVisits';
import { useSetBeneficiados } from 'hooks/useSetBeneficiados';
import * as fieldMsgs from 'constants/formFieldsMessages';

// Secciones del collapse
import DatosGenerales from './components/DatosGenerales';
import Verificadores from './components/Verificadores';
import DatosInicioVisita from './components/DatosInicioVisita';
import UbicacionVisita from './components/UbicacionVisita';
import Beneficiados from '../../../../Beneficiados/Beneficiados';
import Comparecientes from './components/Comparecientes';
import Hallazgos from './components/Hallazgos';
import ServidoresPublicos from './components/ServidoresPublicos';
import Testigos from './components/Testigos';
import ComplementoVisita from './components/ComplementoVisita';
import ContestacionSO from './components/ContestacionSO';
import DesignadosSO from './components/DesignadosSO';
// Fin secciones del collapse
// import { useSetImagesFields } from '../../hooks/useSetImagesFields';
import { useSetImagesAndVideosField } from '../../../../../hooks/useSetImagesAndVideosField';
import './ModalEditarEvento.scss';

// MNI - Llamado a generación de PDF
import { generarPDFMonitoreos } from 'services/monitoreos.service';

const identificadoresForm = {
  datos_generales: [
    'idEstado',
    'idProcesoEspecifico',
    'idAmbito',
    'idDistritoLoc',
    'idDistritoFed',
    'idEventoSIF',
    'acuerdoCOF',
    'fechaAcuerdoAprobado'
  ],
  datos_inicio_visita: [
    'ordenVisita',
    'fechaApertura',
    'horaApertura',
    'fechaCierre',
    'horaCierre'
  ],
  beneficiados: ['tipo_beneficio'],
  ubicacion_visita: ['idMunicipio', 'calle', 'numero', 'colonia', 'codigoPostal', 'referencias'],
  complemento_visita: ['duracionHr', 'duracionMin', 'duracionSeg']
};

export const ModalEditarEvento = ({ onClose, visible, initialData, pagina, pageSize }) => {
  const [form] = Form.useForm();
  const datosUser = useSelector((state) => state.validarUsuario.data);
  const [tipoBeneficiadoInicial, setTipoBeneficiadoInicial] = useState(null);
  const [isVisibleSuccesModal, setIsVisibleSuccessModal] = useState(false);
  const [activeKey, setActiveKey] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  // const { setImagesFields, isLoading: isLoadingImages } = useSetImagesFields();
  const { setImageAndVideoField, isLoading: isLoadingImages } = useSetImagesAndVideosField();
  const { setSignerFields, isLoading: isLoadingSignerImages } = useSetSignerFieldsVisits();

  const setBeneficiados = useSetBeneficiados();
  const [reasonCancel, setReasonCancel] = useState(false);

  // Catalogos
  const procesosElectorales = useSelector(selectCatalogByName(PROCESOS_ELECTORALES));
  const catalogos = useSelector(selectCatalogs);
  const catalogoBeneficiados = useSelector(selectCatalogoBeneficiados);
  const [idProcesoGeneral, setIdProcesoGeneral] = useState(null);

  const getRandomInt = (max) => {
    return Math.floor(Math.random() * max);
  };

  const handleCancel = () => {
    onClose?.();
    setActiveKey([]);
    form.resetFields();
  };

  const handleOK = async () => {
    try {
      setIsLoading(true);
      const values = await form.validateFields();
      if (values.beneficiados.length === 0) {
        dispatch(showAlert('Debes registrar al menos un beneficiado', ALERT_ERROR_TYPE));
        setActiveKey('beneficiados');
        return;
      }
      const payload = {
        ...formatoEdicionMonitoreoEventos(values, catalogos, initialData, catalogoBeneficiados),
        pagina: pagina,
        pageSize: pageSize
      };

      // Se realiza limpieza de valores innecesarios cuando se guarda un beneficiado genérico
      if (values.tipo_beneficio == 1) {
        payload?.visitas?.toUpdate?.[0]?.beneficiados?.forEach((element) => {
          if (element.estatus != 0) {
            element.cargo = '';
            element.nombreBeneficiado = '';
            element.idContabilidad = 0;
          }
        });
      }

      const { success } = await dispatch(upsertMonitoreosEventos(payload));

      // Variable a enviar para generar PDF del monitoreo
      let monitoreoPDF = [
        {
          idMonitoreo: payload.visitas.toUpdate[0].idMonitoreo,
          idTipoMonitoreo: 4,
          tiposActa: [{ id: 6 }]
        }
      ];

      if (success) {
        setIsVisibleSuccessModal(true);
        setIsLoading(false);
        onClose?.();
        setActiveKey([]);
        form.resetFields();

        // Se genera PDF una vez que se han almacenado las Muestras
        let generoPDF = await generarPDFMonitoreos(monitoreoPDF);

        if (generoPDF) {
          console.log('Se generó correctamente el PDF');
        } else {
          console.log('Error al generar el PDF');
        }
      }
    } catch (error) {
      const { errorFields } = error;
      if (errorFields) {
        const [firstError] = errorFields;
        const identifierForm = encontrarActiveKeyPorValor(
          identificadoresForm,
          firstError?.name?.[0]
        );
        if (identifierForm) {
          newScrollToErrorField(errorFields, form);
          setActiveKey([`${identifierForm}`]);
        } else {
          setActiveKey([`${newScrollToErrorField(errorFields, form)}`]);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCollapseChange = (key) => {
    setActiveKey(key);
  };

  const handleIdProcesoGralChange = (e, tipoAsociacionSelecionada) => {
    setIdProcesoGeneral(tipoAsociacionSelecionada.idProcesoElectoral);
  };

  // vincular todos los formularios
  const items = useMemo(
    () => [
      {
        key: 'datos_generales',
        label: 'Datos Generales',
        forceRender: true,
        children: (
          <DatosGenerales form={form} idProcesoGeneral={idProcesoGeneral} isLoading={isLoading} />
        )
      },
      {
        key: 'verificadores',
        label: 'Verificador',
        forceRender: true,
        children: <Verificadores form={form} isLoadingImages={isLoadingSignerImages} />
      },
      {
        key: 'datos_inicio_visita',
        label: 'Datos de inicio de visita',
        forceRender: true,
        children: <DatosInicioVisita form={form} isLoading={isLoading} />
      },
      {
        key: 'ubicacion_visita',
        label: 'Ubicación de la visita',
        forceRender: true,
        children: <UbicacionVisita form={form} isLoading={isLoading} />
      },
      {
        key: 'beneficiados',
        label: 'Beneficiados',
        forceRender: true,
        children: (
          <Beneficiados
            form={form}
            isLoading={isLoading}
            renderBeneficiados={getRandomInt(100)}
            tipoBeneficioInicial={tipoBeneficiadoInicial}
            actionType={!!initialData}
          />
        )
      },
      {
        key: 'comparecientes',
        label: 'Datos del compareciente (Opcional)',
        forceRender: true,
        children: (
          <Comparecientes
            form={form}
            isLoading={isLoading}
            isLoadingImages={isLoadingSignerImages}
          />
        )
      },
      {
        key: 'hallazgos',
        label: 'Hallazgos',
        forceRender: true,
        children: <Hallazgos form={form} isLoading={isLoading} isLoadingImages={isLoadingImages} />
      },
      {
        key: 'servidores_publicos',
        label: 'Servidores públicos (Opcional)',
        forceRender: true,
        children: <ServidoresPublicos form={form} isLoading={isLoadingSignerImages} />
      },
      {
        key: 'testigos',
        label: 'Testigos',
        forceRender: true,
        children: <Testigos form={form} isLoadingImages={isLoadingSignerImages} />
      },
      {
        key: 'complemento_visita',
        label: 'Complemento de la visita',
        forceRender: true,
        children: <ComplementoVisita form={form} isLoading={isLoading} />
      },
      {
        key: 'contestacion_so',
        label: 'Contestación del Sujeto Obligado (Opcional)',
        forceRender: true,
        children: <ContestacionSO form={form} isLoading={isLoading} />
      },
      {
        key: 'designado_so',
        label: 'Designado por el Sujeto Obligado (Opcional)',
        forceRender: true,
        children: <DesignadosSO form={form} isLoading={isLoading} />
      }
    ],
    [
      isLoading,
      form,
      tipoBeneficiadoInicial,
      isLoadingImages,
      isLoadingSignerImages,
      idProcesoGeneral
    ]
  );

  useEffect(() => {
    if (!visible || !initialData?.tableRow) return;
    const formatedMonitoreo = formatFromBackToForm(initialData.tableRow);
    form.setFieldsValue(formatedMonitoreo);
    // const idFormato = initialData.tableRow.formatos?.[0]?.idFormato;
    setImageAndVideoField(initialData.tableRow.hallazgos || [], form);
    setSignerFields(initialData.tableRow.visitas?.[0] || [], form);
    const beneficiados = initialData.tableRow.visitas?.[0]?.beneficiados || [];
    const tipoBeneficio = initialData.tableRow.hallazgos?.[0]?.tipoBeneficio;
    setBeneficiados(beneficiados, tipoBeneficio, form);
    setTipoBeneficiadoInicial(tipoBeneficio);
    if (formatedMonitoreo.motivoCancelacion) {
      setReasonCancel(true);
    }
    setIdProcesoGeneral(initialData.tableRow.idProcesoGral);
  }, [visible, initialData]);

  return (
    <>
      <InfoModal
        visible={isVisibleSuccesModal}
        onClose={() => {
          setIsVisibleSuccessModal(false);
          setReasonCancel(false);
        }}
      />
      <Modal
        title="Editar"
        wrapClassName="modal-formulario-monitoreo"
        open={visible}
        width="90%"
        onCancel={() => {
          handleCancel();
          setReasonCancel(false);
        }}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { marginLeft: '-1em' }, loading: isLoading }}
        okText={initialData ? 'Guardar' : 'Generar visita'}
        onOk={handleOK}>
        <LoadingCard visible={isLoading} />
        <div>
          <div>
            <span className="folio-moni">
              Folio de monitoreo:{' '}
              <span className="value-folio">{initialData?.tableRow?.folio}</span>
            </span>
          </div>
          <div className="modal-formulario-subtitulo">
            <span className="modal-formulario-subtitulo-descripcion">
              Captura la información solicitada.
            </span>
            <span className="modal-formulario-subtitulo-requeridos">*Campos obligatorios.</span>
          </div>
          <Form layout="vertical" form={form}>
            <Row>
              <Col span={8}>
                <Form.Item
                  label="Proceso Electoral"
                  required
                  name="idProcesoGral"
                  rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}
                  style={{ width: '20em', margin: '1em 0' }}>
                  <Select
                    options={procesosElectorales}
                    placeholder="Selecciona el Proceso Electoral"
                    fieldNames={{
                      value: 'idProcesoElectoral',
                      label: 'descripcion'
                    }}
                    disabled={isLoading}
                    onChange={handleIdProcesoGralChange}
                  />
                </Form.Item>
              </Col>
              {datosUser.rol.includes('VALIDADOR') || datosUser.rol.includes('ADMIN') ? (
                <div>
                  {initialData && (
                    <EstatusFormulario
                      reasonCancel={reasonCancel}
                      setReasonCancel={setReasonCancel}
                    />
                  )}
                </div>
              ) : null}
            </Row>
          </Form>
          <Accordion
            items={items}
            className="modal-formulario-secciones"
            activeKey={activeKey}
            onChange={handleCollapseChange}
          />
        </div>
      </Modal>
    </>
  );
};

ModalEditarEvento.propTypes = {
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  initialData: PropTypes.shape({
    tableRow: PropTypes.shape({
      hallazgos: PropTypes.arrayOf(
        PropTypes.shape({
          tipoBeneficio: PropTypes.number
        })
      ),
      visitas: PropTypes.arrayOf(
        PropTypes.shape({
          idFormato: number,
          beneficiados: PropTypes.arrayOf(PropTypes.shape({}))
        })
      ),
      idProcesoGral: PropTypes.number
    })
  })
};

ModalEditarEvento.defaultProps = {
  visible: true,
  initialData: null
};
